<div class="flex flex-col gap-3 p-6">
  <div class="flex items-center justify-between px-[8px]">
    <h1 class="textTabsColor text-[22px] font-[700]" i18n="@@ppReasonsListPageTitle">Partially Package Reasons</h1>

    <button
      (click)="navigateToAddReason()"
      class="add-button flex items-center justify-center gap-2">
      <app-add-icon />
      <span i18n="@@ppReasonsCreateNewReason">Create New Reason</span>
    </button>
  </div>

  <app-p-p-reason-list />
</div>
